<template>
    <div class="hypothec-page">
        <div class="container">
            <div class="page-title">
                <h1>Ипотека</h1>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import store from '@/store.js'
    export default {
        name: 'hypothec--page',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            // aboutPage: 'loadAboutPage',
        }),
        methods: {
        },
        beforeCreate() {
            document.body.dataset.page = 'hypothec';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    // @import '@/styles/components/about/about-page.scss';
</style>